import { managerAxios } from './baseApis';
export const getTeamCalendar = async () => {
    const endpoint = 'teamCalendarEvents';
    return await managerAxios.get(endpoint);
};
